import { render } from "./GradePercent.vue?vue&type=template&id=1a77741e&scoped=true&ts=true"
import script from "./GradePercent.vue?vue&type=script&lang=ts"
export * from "./GradePercent.vue?vue&type=script&lang=ts"

import "./GradePercent.vue?vue&type=style&index=0&id=1a77741e&scoped=true&lang=scss"

import exportComponent from "/builds/rahmet/products/grading-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a77741e"]])

export default __exports__